import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from '@alltrails/shared/denali/components/Typography';
import { Key } from 'react';
import Link from '@alltrails/shared/denali/components/Link';
import * as styles from './OurLeadershipTeam.module.scss';
import OurLeadershipCard from './OurLeadershipCard';

import ronAvif from './ron.avif';
import ronWebp from './ron.webp';
import ronJpg from './ron.jpg';

import carlyAvif from './carly.avif';
import carlyWebp from './carly.webp';
import carlyJpg from './carly.jpg';

import jamesAvif from './james.avif';
import jamesWebp from './james.webp';
import jamesJpg from './james.jpg';

import willAvif from './will.avif';
import willWebp from './will.webp';
import willJpg from './will.jpg';

import meaghanAvif from './meaghan.avif';
import meaghanWebp from './meaghan.webp';
import meaghanJpg from './meaghan.jpg';

const leaders = [
  {
    bio1: (
      <FormattedMessage defaultMessage="Ron is passionate about building great companies that help people have authentic, organic, real-world experiences. In 2005, Ron co-founded Liftopia, the global leader in ski lift ticket bookings, and most recently was Head of Growth at Yelp Reservations. Ron is committed to mentoring other entrepreneurs. He frequently advises members of the 500 Global community, and speaks at industry and thought leadership events." />
    ),
    bio2: (
      <FormattedMessage
        defaultMessage="Ron attended UCLA, where he earned his bachelor’s degree in Mass Communications, and lives in the East Bay, California, with his wife Jenny, and their three children. Ron loves riding his mountain bike, but his all-time favorite trail is the <a>Na Pali Coast Trail</a>."
        values={{
          a: (chunks: string) => (
            <Link className={styles.link} target="_blank" href="/trail/hawaii/kaua-i--2/na-pali-coast-kalalau-trail">
              {chunks}
            </Link>
          )
        }}
      />
    ),
    name: <FormattedMessage defaultMessage="Ron Schneidermann" />,
    photoAvif: ronAvif,
    photoJpg: ronJpg,
    photoWebp: ronWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Executive Officer" />
  },
  {
    bio1: (
      <FormattedMessage defaultMessage="As Chief Marketing Officer, Carly works to help millions of people around the world discover AllTrails and be inspired to get outside. Carly leads AllTrails’ highly data-driven marketing team, leveraging digital and traditional channels to reach new people and empower them to experience the goodness of the outdoors. Carly brings a broad range of brand and performance marketing experience and previously led marketing at Minted and e-commerce marketing at Levi Strauss." />
    ),
    bio2: (
      <FormattedMessage
        defaultMessage="Carly graduated from Bowdoin College and earned her MBA from Harvard Business School. Carly loves hiking near her home in Marin; the <a>Tennessee Valley to Muir Beach</a> trail is one of her all-time favorites."
        values={{
          a: (chunks: string) => (
            <Link className={styles.link} href="/trail/us/california/tennessee-valley-to-muir-beach-via-coastal-trail" target="_blank">
              {chunks}
            </Link>
          )
        }}
      />
    ),
    name: <FormattedMessage defaultMessage="Carly Smith Costello" />,
    photoAvif: carlyAvif,
    photoJpg: carlyJpg,
    photoWebp: carlyWebp,
    pronouns: <FormattedMessage defaultMessage="(she/her)" />,
    title: <FormattedMessage defaultMessage="Chief Marketing Officer" />
  },
  {
    bio1: (
      <FormattedMessage defaultMessage="As Chief Technology Officer, James leads the web and mobile engineering teams responsible for building the app across iOS, Android, and web. James has a passion for both the outdoors and technology, fueling his excitement to join the AllTrails team. Previously, at GoPro, he helped shape the cloud engineering team and grow the GoPro Plus subscription service. Prior to GoPro, James was a key contributor to enterprise and consumer software companies ranging from grassroot startups to large corporations." />
    ),
    bio2: (
      <FormattedMessage
        defaultMessage="James attended The University of Alabama and received a bachelor's degree in management information systems and computer science. His extracurriculars included founding the Kayak club and rowing in the Crew club. As a San Francisco resident, James loves exploring The Bay Area and snowboarding in Tahoe. In the summer you may find him exploring <a>Ropi Lake in the Desolation Wilderness</a> with friends."
        values={{
          a: (chunks: string) => (
            <Link className={styles.link} href="/trail/us/california/horsetail-falls-to-ropi-lake" target="_blank">
              {chunks}
            </Link>
          )
        }}
      />
    ),
    name: <FormattedMessage defaultMessage="James Graham" />,
    photoAvif: jamesAvif,
    photoJpg: jamesJpg,
    photoWebp: jamesWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Technology Officer" />
  },
  {
    bio1: (
      <FormattedMessage defaultMessage="Will Masterson is Chief Financial Officer, where he’s helped guide AllTrails’ growth and financial excellence since its latest round of funding and partnership with Spectrum Equity. Prior to AllTrails, Will was the senior director of corporate finance and investor relations at Visa." />
    ),
    bio2: (
      <FormattedMessage
        defaultMessage="He earned his M.B.A. from Harvard Business School and his bachelor’s degree in economics from The University of Kentucky. Will lives in Oakland, CA with his family, and loves endurance sports, especially mountain biking on the <a>Soquel Demonstration Forest Flow Trail</a>."
        values={{
          a: (chunks: string) => (
            <Link className={styles.link} href="/trail/us/california/soquel-demonstration-forest-flow-trail" target="_blank">
              {chunks}
            </Link>
          )
        }}
      />
    ),
    name: <FormattedMessage defaultMessage="Will Masterson" />,
    photoAvif: willAvif,
    photoJpg: willJpg,
    photoWebp: willWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Financial Officer" />
  },
  {
    bio1: (
      <FormattedMessage defaultMessage="Meaghan Praznik is head of communications and outreach at AllTrails, where she oversees media and influencer relations, communications strategy and community-building efforts. With extensive experience in the health, wellness, outdoor and lifestyle industry, Meaghan is passionate about driving communications for values-based companies looking to use their platform for good. Meaghan previously managed public relations at Clif Bar & Company and gained valuable agency experience at Burson-Marsteller." />
    ),
    bio2: (
      <FormattedMessage
        defaultMessage="She earned her degree in public relations from Gonzaga University, and still daydreams about heading back to <a>Crested Butte to run the Lupine, Gunsight Connection and Lower Loop Trail</a>."
        values={{
          a: (chunks: string) => (
            <Link className={styles.link} href="/trail/us/colorado/lupine-gunsight-connection-and-lower-loop-trail" target="_blank">
              {chunks}
            </Link>
          )
        }}
      />
    ),
    contact: 'mailto:press@alltrails.com',
    name: <FormattedMessage defaultMessage="Meaghan Praznik" />,
    photoAvif: meaghanAvif,
    photoJpg: meaghanJpg,
    photoWebp: meaghanWebp,
    pronouns: <FormattedMessage defaultMessage="(she/her)" />,
    title: <FormattedMessage defaultMessage="Head of Communications" />
  }
];

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A10812&t=cQ6ofstqefHmuy2U-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=2506%3A11457&t=aadNlnIKQJkCzSxu-4
export default function OurLeadershipTeam() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="heading700">
          <FormattedMessage defaultMessage="Our leadership team" />
        </Typography>
        <div className={styles.leaders}>
          {leaders.map((leader, index) => (
            <OurLeadershipCard leader={leader} key={index as Key} />
          ))}
        </div>
      </div>
    </div>
  );
}

export type Leader = typeof leaders[number];
